import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BLUE_LIGHT, GRAY} from 'ui-library/Colors';

import {LabAutomationTransform} from '../RunSchemaSpecConstants';
import {FormErrors, isFormErrorsEmpty, validateTransform} from './transform-form/TransformFormUtils';

export interface AddTransformButtonProps {
  disabled?: boolean;
  transform: LabAutomationTransform;
  setFormErrors: (formErrors: FormErrors) => void;
  handleSetTransform: (transform: LabAutomationTransform) => void;
}

export function AddTransformButton(props: AddTransformButtonProps): JSX.Element | null {
  return (
    <Button
      className={classNames(css(styles.addTransformButton), {
        [css(styles.addTransformButtonDisabled)]: props.disabled,
      })}
      onClick={() => {
        const newFormErrors = validateTransform(props.transform, true);
        props.setFormErrors(newFormErrors);
        if (isFormErrorsEmpty(newFormErrors)) {
          props.handleSetTransform({transformType: null});
        }
      }}
      disabled={props.disabled}
      icon="compose"
      text="Add transform"
      size={ButtonSize.SMALL}
      buttonStyle={ButtonStyle.SECONDARY_WHITE}
    />
  );
}

const styles = StyleSheet.create({
  field: {
    width: '50%',
    marginBottom: '8px',
  },
  addTransformButton: {
    color: BLUE_LIGHT,
    fontWeight: 600,
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    marginRight: '6px',
    marginLeft: '-9px',
    marginTop: '20px',
  },
  addTransformButtonDisabled: {
    color: GRAY,
  },
});
